import { useState } from 'react';
import { api } from '../lib/api';
import { useStore } from '../lib/store';
import { makeT } from '../lib/i18n';

export function Login({ onLogin }: { onLogin: () => void }) {
  const lang = useStore((s) => s.lang);
  const toggleTheme = useStore((s) => s.toggleTheme);
  const theme = useStore((s) => s.theme);
  const t = makeT(lang);
  const [pw, setPw] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(''); setLoading(true);
    try {
      await api.post('/api/auth/login', { password: pw });
      onLogin();
    } catch (e: any) {
      setErr(e.message === 'HTTP 401' ? t('login.error401') : e.message === 'HTTP 429' ? t('login.error429') : t('login.err'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app">
      <header className="header">
        <h1>{t('login.title')}</h1>
        <div className="actions">
          <button className="icon-btn" onClick={() => useStore.getState().setLang(lang === 'zh' ? 'en' : 'zh')}>
            {lang === 'zh' ? 'EN' : '中'}
          </button>
          <button className="icon-btn" onClick={toggleTheme}>{theme === 'dark' ? '☀️' : '🌙'}</button>
        </div>
      </header>
      <form className="login" onSubmit={submit}>
        <div className="brand"><h2>{t('login.title')}</h2></div>
        <p className="sub">{t('login.subtitle')}</p>
        <input
          type="password"
          autoFocus
          value={pw}
          onChange={(e) => setPw(e.target.value)}
          placeholder={t('login.placeholder')}
          disabled={loading}
        />
        <button type="submit" disabled={loading || !pw}>
          {loading ? '…' : t('login.submit')}
        </button>
        {err && <div className="err">{err}</div>}
      </form>
    </div>
  );
}
